<template>
  <div class="repay" v-if="orderData">
    <Address :addressData="address"></Address>

    <payment :payType="payType" @paySelect="paySelect" />

    <div class="order-btn">
      <div class="btn">
        <div class="left">
          <span>{{ $t("message.order.allSum") }}</span
          ><span class="money"
            >{{ payAmountMoney.symbol }}
            {{ $currencyFormatter(payAmountMoney.number) }}</span
          >
        </div>
        <van-button class="right global_pointer" @click="orderClick" type="default">
          {{ $t("message.order.repayBtn") }}
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
import Address from "@/components/order/address";
import payment from "@/components/order/payment";
import { Checkbox, Button } from "vant";
import api from "@/api/api_list";
import { plateForm } from '@/utils'

export default {
  components: {
    Address,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    payment,
  },
  data() {
    return {
      address: null,
      orderData: null,
      payAmountMoney: "",
      paymentMethod: "",
      payType: "3",
    };
  },
  created() {},
  computed: {},
  mounted() {
    this.orderId = this.$route.query.orderId;
    this.fetchDetail();
  },
  methods: {
    async fetchDetail() {
      try {
        const { result } = await api.get_order_detail({
          orderId: this.orderId,
        });
        const {
          consigneeAddress,
          consigneeName,
          consigneePhone,
          payAmountMoney,
          customerNote,
        } = result;
        this.address = { consigneeAddress, consigneeName, consigneePhone };
        this.payAmountMoney = payAmountMoney || {};
        this.message = customerNote;
        this.orderData = result;
      } catch (e) {
        console.error(e);
      }
    },
    paySelect(e) {
      this.selectPay = e;
      this.payType = e;
    },
    async orderClick() {
       this.$loading('loading...');
        const { code, result , msg} = await api.repayment({
          customerNote: this.message,
          orderId: this.orderId,
          payType: this.payType, 
        });

        this.$loading.close()

        if (code !== 0) {
          this.$toast(msg) 
          return 
        }
        const { prePayInfo, toPayError, orderId, transactionNo } =
              result;
        if (toPayError) {
            this.$toast(this.$t("message.order.payError"));
            return;
          }
        let fuc;
        if (this.payType == 1) {
          fuc = "aliPayInfo";
        } else if (this.payType == 2) {
          fuc = "wxpayWebPreInfo";
        } else if(this.payType == 3){
            const { stripePaymentResult = {} } = prePayInfo;
            const { clientSecret } = stripePaymentResult;
            if (!clientSecret) {
              this.$loading.close();
              this.return;
            }
            this.pay(clientSecret, transactionNo);
            return;
        }else {
          fuc = "nhpUnionPayInfo";
        }
        
        if( plateForm().isIOS ){
          document.write( prePayInfo[fuc] );
        }else{
          // ios可以这样 andorid用另外一种方式
          document.documentElement.innerHTML = prePayInfo[fuc];
          setTimeout(()=>{
            document.forms[0].submit();
          });
        }
    },
  },
};
</script>
<style lang="less" scoped>
.repay {
  .title-item {
    // width: 100%;
    height: 46px;
    background-color: #fff;
    font-family: PingFangSC-Regular;
    color: #161a1a;
    // padding: 500px;
    padding: 5px 10px 5px 0;
    .left {
      font-size: 16px;
      color: #161a1a;
      letter-spacing: 0;
      line-height: 18px;
    }
    .right {
      height: 100%;
      // float: right;
      display: inline-flex;
      font-family: PingFangSC-Regular;
      font-size: 13px;
      letter-spacing: 0;
      align-items: center;
      justify-content: flex-end;
      span {
        float: left;
      }
      img {
        float: left;
        font-size: 0;
        width: 16px;
        height: 16px;
      }
    }
  }
  .message {
    margin-top: 12px;
    padding-left: 10px;
    border-top: 0.5px solid #e5e8e8;
    display: flex;
    align-items: center;
    .message-left {
      height: 100%;
      font-size: 16px;
      line-height: 35px;
    }
    .message-right {
      flex: 1;
      padding: 0 15px;
      input {
        width: 100%;
        height: 100%;
      }
    }
  }
  .order-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    .tips {
      height: 24px;
      padding-left: 10px;
      line-height: 24px;
      background-color: #e5e8e8;
      font-family: PingFangSC-Regular;
      font-size: 11px;
      color: #161a1a;
      letter-spacing: 0;
      .agreement {
        color: #333333;
      }
    }
    .btn {
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-family: PingFangSC-Regular;
      letter-spacing: 0;
      .left {
        display: flex;
        justify-content: flex-start;
        width: 60%;
        background-color: #fff;
        padding-left: 10px;
        font-size: 14px;
        color: #161a1a;
        .money {
          color: #b4282d;
          vertical-align: middle;
        }
      }
      .right {
        float: left;
        width: 40%;
        height: 100%;
        background-color: #333333;
        color: #ffffff;
        letter-spacing: 1px;
        font-size: 16px;
        text-align: center;
      }
    }
  }
}

.pay-item {
  display: flex;
  height: 46px;
  padding: 5px 10px;
  font-size: 16px;
  justify-content: space-between;
  .left {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    letter-spacing: 0;
    display: flex;
    align-items: center;
    span {
      float: left;
      margin-left: 5px;
      line-height: 24px;
      font-size: 14px;
      color: #161a1a;
    }
    .payCard {
      display: inline-block;
      width: 41px;
      height: 24px;
      background: url("https://fr-static.shopshops.top/20200419/patCard.170377dfd985234e.png")
        no-repeat;
      background-size: cover;
    }
    .unionCard {
      background: url("https://fr-static.shopshops.top/20210121/logo_zh_CN.46cd58bcd83f5dad.png")
        no-repeat;
      background-size: cover;
    }
  }
  .right {
    display: flex;
    font-size: 16px;
    align-items: center;
    span {
      margin-right: 5px;
    }
  }
}
// 卡支付
.StripeElement {
  box-sizing: border-box;

  // height: 2000px;

  padding: 10px 12px;

  border: 0.5px solid transparent;
  border-radius: 2px;
  background-color: white;

  box-shadow: 0 0.5px 1.5px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 0.5px 1.5px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
.card-errors {
  font-size: 14px;
  color: #fa755a;
  // padding: 500px 0;
}
</style>
